<template>
  <section class="section" id="" style="margin-top:100px; margin-bottom: 50px;">
    

    <div class="container">
      <div class="row align-items-center rounded-lg">
        <div
          class="col-12 rounded-lg"
          style="
            margin: 10px;
            box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.3);
            padding: 20px;
          "
        >
          <div class="row justify-content-center text-center mb-5">
            <div class="" data-aos="fade-up" style="width:100%">
              <h2 class="section-heading" style="text-align: left;">Forfaits et tarifs</h2>
            </div>
          </div>
          

          <div class="row" style="padding:20px; font-size: 20px;">
            

            <p style="color: black">
                Peu importe vos addictions. Nous avons des plans parfait et favorable à votre budget.
On ne va pas s’étaler sur le sujet des économies que vous ferez si vous arrêter de fumer, car vous faites ce que vous voulez de votre argent mais cela dit on ne peut pas négliger l’économie et surtout le capital vie gagner..
            </p>

            
          </div>
          <div class="row" style="justify-content:center; padding: 20px">
        <div class="col-md-4" data-aos="fade-up" data-aos-delay="" style="margin-bottom:10px">
          <div class="feature-1 text-center rounded-lg" style="background-color:inherit; display: flex; flex-direction: column; padding: 20px; margin-bottom: 20px; height:100%; justify-content: space-between;">
            <h3 class="mb-3 service-name-red"><span style="font-size: 50px; color:#38B44A;">10 MIN d'appel téléphonique GRATUIT</span></h3>
            <p style="color:#38B44A; font-size:30px; text-align:left">
                Consultation téléphonique.
            </p>
            <div style="align-items:flex-start; display: flex; flex-direction:column; justify-content: left; margin: 30px 0px">
                <p><i class="bi bi-check-circle-fill"></i> Diagnostic téléphonique gratuit</p>
                <p><i class="bi bi-check-circle-fill"></i> Conseils personnalisés</p>
                <p><i class="bi bi-check-circle-fill"></i> Accompagnement professionnel, confidentiel</p>
            </div>
            <button style="background-color: #38B44A; padding:20px; border:none" class="rounded-lg"><a href='/book-appointment'>Book Appointment</a></button>
          </div>
        </div>
        <!--div class="col-md-4" data-aos="fade-up" data-aos-delay="" style="margin-bottom:10px">
          <div class="feature-1 text-center rounded-lg" style="background-color:inherit; display: flex; flex-direction: column; padding: 20px; margin-bottom: 20px; height:100%">
            <h3 class="mb-3 service-name-red"><span style="font-size: 50px; color:#38B44A;">€50</span>/session</h3>
            <p style="color:#38B44A; font-size:30px; text-align:left">
                Traitement de la douleur.
            </p>
            <div style="align-items:flex-start; display: flex; flex-direction:column; justify-content: left; margin: 30px 0px">
                <p><i class="bi bi-check-circle-fill"></i></p>
                <p><i class="bi bi-check-circle-fill"></i></p>
                <p><i class="bi bi-check-circle-fill"></i></p>
            </div>
            <button style="background-color: #38B44A; padding:20px; border:none" class="rounded-lg">Book Appointment</button>
          </div>
        </div-->
        <div class="col-md-4" data-aos="fade-up" data-aos-delay="" style="margin-bottom:10px">
          <div class="feature-1 text-center rounded-lg" style="background-color:inherit; display: flex; flex-direction: column; padding: 20px; margin-bottom: 20px; height:100%; justify-content: space-between;">
            <h3 class="mb-3 service-name-red"><span style="font-size: 50px; color:#38B44A;">€150</span>/ la séance</h3>
            <p style="color:#38B44A; font-size:30px; text-align:left">
                Traitement des addictions.
            </p>
            <div style="align-items:flex-start; display: flex; flex-direction:column; justify-content: left; margin: 30px 0px">
                <p><i class="bi bi-check-circle-fill"></i> Étude des besoins</p>
                <p><i class="bi bi-check-circle-fill"></i> Recherche des points</p>
                <p><i class="bi bi-check-circle-fill"></i> Traitement laser</p>
                <p><i class="bi bi-check-circle-fill"></i> Nouvelle vie</p>
            </div>
            <button style="background-color: #38B44A; padding:20px; border:none" class="rounded-lg"><a href='/book-appointment'>Book Appointment</a></button>
          </div>
        </div>
        <div class="col-md-4" data-aos="fade-up" data-aos-delay="" style="margin-bottom:10px">
          <div class="feature-1 text-center rounded-lg" style="background-color:inherit; display: flex; flex-direction: column; padding: 20px; margin-bottom: 20px; height:100%; justify-content: space-between;">
            <h3 class="mb-3 service-name-red"><span style="font-size: 50px; color:#38B44A;">€50</span>/ la séance</h3>
            <p style="color:#38B44A; font-size:30px; text-align:left">
                Séance garantie annuel.
            </p>
            <div style="align-items:flex-start; display: flex; flex-direction:column; justify-content: left; margin: 30px 0px">
                <p><i class="bi bi-check-circle-fill"></i> Garantie 1 ans si rechute dans l’année Une nouvell séance offert</p>
                <!--p><i class="bi bi-check-circle-fill"></i></p>
                <p><i class="bi bi-check-circle-fill"></i></p-->
            </div>
            <button style="background-color: #38B44A; padding:20px; border:none" class="rounded-lg"><a href='/book-appointment'>Book Appointment</a></button>
          </div>
        </div>
        <div class="col-md-4" data-aos="fade-up" data-aos-delay="" style="margin-bottom:10px">
          <div class="feature-1 text-center rounded-lg" style="background-color:inherit; display: flex; flex-direction: column; padding: 20px; margin-bottom: 20px; height:100%; justify-content: space-between;">
            <!--h3 class="mb-3 service-name-red"><span style="font-size: 50px; color:#38B44A;">€50</span>/session</h3-->
            <p style="color:#38B44A; font-size:30px; text-align:left">
                Séance à domicile.
            </p>
            <div style="align-items:flex-start; display: flex; flex-direction:column; justify-content: left; margin: 30px 0px; color: black">
                <p style="text-align: left;"><i class="bi bi-check-circle-fill"></i> A définir selon le périmètre d’intervention</p>
                <p style="text-align: left;"><i class="bi bi-check-circle-fill"></i> Selon le nombre de personnes à traiter</p>
                <p style="text-align: left;"><i class="bi bi-check-circle-fill"></i> Idéal pour les personnes à mobilité réduite, on pense à vous</p>
                <p style="text-align: left;"><i class="bi bi-check-circle-fill"></i> CE, comité d’entreprise.</p>
            </div>
            <button style="background-color: #38B44A; padding:20px; border:none" class="rounded-lg"><a href='/contact-us'>Citation requise</a></button>
          </div>
        </div>
        <div class="col-md-4" data-aos="fade-up" data-aos-delay="" style="margin-bottom:10px">
          <div class="feature-1 text-center rounded-lg" style="background-color:inherit; display: flex; flex-direction: column; padding: 20px; margin-bottom: 20px; height:100%;justify-content: center">
            <!--h3 class="mb-3 service-name-red"><span style="font-size: 50px; color:#38B44A;">€50</span>/session</h3-->
            <p style="color:#f21e1e; font-size:30px; text-align:left">
                Vous n'arrivez pas à trouver ce que vous cherchez?.
            </p>
            
            <button style="background-color: #38B44A; padding:20px; border:none" class="rounded-lg"><a href='/contact-us'>Envoyer une demande</a></button>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import img1 from "@/assets/img/im1.jpg";
import img2 from "@/assets/img/im2.jpg";
export default {
  data() {
    return {
      view: {
        slowShow: false,
        img1: img1,
        img2: img2,
      },
    };
  },
  mounted() {
    this.handleAnimation();
  },
  methods: {
    handleAnimation() {
      setTimeout(() => {
        this.view.slowShow = true;
      }, 1000);
    },
  },
};
</script>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.service-name-red{
    text-align: left;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
@media screen and (max-width: 992px) {
  .hero-section {
    height: 154vh;
  }
  .hero-section .iphone-wrap .phone-1 {
    margin-left: 0%;
  }
  .hero-section .iphone-wrap .phone-2 {
    margin-left: 20%;
  }
}

@media screen and (max-width: 576px) {
  .hero-section .iphone-wrap .phone-2 {
    margin-left: 7%;
  }
}
</style>
